module.exports = __webpack_public_path__ + "static/media/mobileAboutTile.b1302a28.svg";